export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    lineNumbers: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    downloading: Boolean,
    sort: Object,
    page: Number,
    perPage: Number,
    pageSize: Array,
    totalPage: Number,
    totalRecords: Number,
    footerAmount: [String, Number],
    downloadable: {
      type: Boolean,
      default: false,
    },
    customFilters: {
      type: Array,
      default: () => [],
    },
    isReport: false,
  },
};
